import { ProvinceService } from "../../../../services/http/business/province/provinces.service";
import { ErrorsService } from "../../../../services/common/errors.service";
import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IProvince } from "src/app/interfaces/province";
import { ICity } from "src/app/interfaces/city";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { TranslateService } from "@ngstack/translate";
import { IRegister } from "src/app/interfaces/register";
import * as moment from "jalali-moment";
import { CityService } from "src/app/services/http/business/city/city.service";
import { ErrorStateMatcher } from "@angular/material/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SoundEnum } from "src/app/enums/sound.enum";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { environment } from "src/environments/environment";
import { MatSelect, MatDialog } from "@angular/material";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { GonbadSettingService } from "src/app/services/http/business/gonbadSetting/gonbadSetting.service";
import { MajorDegreeService } from "src/app/services/http/business/majorDegree/major-degree.service";
import { IMajorDegree } from "src/app/interfaces/majorDegree";
import { JobService } from "src/app/services/http/business/job/job.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-register-form",
  templateUrl: "./register-form.component.html",
  styleUrls: ["./register-form.component.css"],
  providers: [ErrorsService]
})
export class RegisterFormComponent implements OnInit {
  @Output() register = new EventEmitter<any>();

  form: FormGroup;
  provinceList: IProvince;
  cityList: ICity;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  matcher = new ErrorStateMatcher();
  maxDate: Date;
  introductionMethodList: any;
  jobList: any;
  majorList: IMajorDegree[];
  degreeList: IMajorDegree;
  returnNapto = false;

  constructor(
    private activeRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private majorService: MajorDegreeService,
    private jobService: JobService,
    private accountService: AccountService,
    private dialog: MatDialog,
    private gonbadSettingService: GonbadSettingService,
    private cityService: CityService,
    private provinceService: ProvinceService
  ) { }

  ngOnInit() {
    debugger
    this.activeRoute.params.subscribe(params => {
      if (params['name'] && params['name'] == 'napto') {
        this.returnNapto = true;
      }
    })

    this.maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 6));
    this.form = this.fb.group(
      {
        NationalCode: [
          null,
          Validators.compose([
            Validators.required,
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(10),
            Validators.maxLength(12)
          ])
        ],
        Password: [
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(30)
          ])
        ],
        RePassword: [null, Validators.compose([Validators.required])],

        FirstName: [
          null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern("([\u0600-\u06FF 0-9-]+)")
          ])
        ],
        LastName: [
          null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern("([\u0600-\u06FF 0-9-]+)")
          ])
        ],
        FatherName: [
          null,
          Validators.compose([
            Validators.maxLength(50),
            Validators.pattern("[\u0600-\u06FF 0-9-]+")
          ])
        ],
        FirstNameEn: [
          null,
          Validators.compose([
            Validators.maxLength(50),
            Validators.pattern("([A-Za-z0-9-]+)")
          ])
        ],
        LastNameEn: [
          null,
          Validators.compose([
            Validators.maxLength(50),
            Validators.pattern("([A-Za-z0-9-]+)")
          ])
        ],
        DegreeId: [null],
        MajorId: [null],
        JobId: [null],
        BirthDate: [null, Validators.compose([Validators.required])],

        PlaceCityId: [null, Validators.compose([Validators.required])],

        CertificatePlaceCityId: [null],

        CellPhoneNumber: [
          null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(11),
            Validators.pattern("^(09[0-9][0-9]{8})?$")
          ])
        ],
        IntroductionMethodId: [
          null,
          Validators.compose([
            Validators.required
          ])
        ],

        Email: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+.[a-zA-Z]{2,5}(.[a-zA-Z]{2,5}){0,1}"
            )
          ])
        ],

        CertificateNo: [null, Validators.compose([Validators.maxLength(10)])],

        Gender: [null, Validators.compose([Validators.required])],

        ProvinceId: [null, Validators.compose([Validators.required])],
        HomePhone: [null],
        Address: [null, Validators.required]
      }
    );
    this.getMajor();
    this.getjob();
    this.loadProvience();
    this.loadIntroductionMethod();
  }

  loadProvience() {
    this.provinceService.GetList().subscribe(res => {
      this.provinceList = res;
    });
  }

  getMajor() {
    this.majorService.list().subscribe(
      res => {
        this.degreeList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getjob() {
    this.jobService.list().subscribe(res => {
      this.jobList = res.DataList;
    })
  }

  loadMajor(element: MatSelect) {
    this.majorService.degreeList(element.value).subscribe(
      res => {
        this.majorList = res.EduMajors;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  loadIntroductionMethod() {
    this.accountService.getIntroductionMethodList().subscribe(res => {
      this.introductionMethodList = res;
    });
  }


  loadCity(element: MatSelect) {
    this.cityService.GetList(element.value).subscribe(res => {
      this.cityList = res;
    });
  }

  submit(form: IRegister) {
    let _this = this;
    this.gonbadSettingService.listGonbadSetting('TermsAndConditions').subscribe(res => {
      const confirm: IConfirm = {
        accept: true,
        message: res[0].KeyValue,
        alert: null,
        yesLabel: this.translate.get("label.yes"),
        noLabel: this.translate.get("label.no")
      };
      this.dialog
        .open(ConfirmComponent, {
          width: "700px",
          data: confirm
        })
        .afterClosed()
        .subscribe(res => {
          if (res) {
            this.errors = new Array();
            form.BirthDate = moment
              .from(form.BirthDate, "en")
              .utc(true)
              .format(environment.dateFormat);
            //if (form.Email)
            //form.Email = null;
            this.accountService.register(form).subscribe(
              res => {
                this.snackBar.OpenSnackBar(
                  this.translate.get("success.confirmationCodeHasBeenSent"),
                  "ok",
                  5000,
                  SoundEnum.beep
                );

                form.timer = res.returnValue * 60;
                res.returnValue2 == "again"
                  ? (form.hasbeenRegisterd = true)
                  : (form.hasbeenRegisterd = false);
                this.accountService.updateFormData(form);
                if (!_this.returnNapto)
                  this.router.navigate(["registerConfirmation"]);
                else
                  this.router.navigate(['registerConfirmation', 'napto']);
              },
              error => {
                // this.errObject = this.errorService.getError(error);
                // this.param = this.errorService.objectError(this.errObject);
                // this.errors = this.errorService.returnError(error);
                this.errorList = this.errorService.getErrorList(error.error);
              }
            );
          }
        });
    })










  }
}
